// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/workspace.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateWorkspaceRequest, DeleteWorkspaceRequest, GetWorkspaceRequest, ListWorkspacesRequest, ListWorkspacesResponse, ReportProblemRequest, ReportProblemResponse, UpdateWorkspaceRequest, UploadWorkspaceAvatarRequest, Workspace } from "./workspace_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.WorkspaceService
 */
export const WorkspaceService = {
  typeName: "omnios.v1.WorkspaceService",
  methods: {
    /**
     * @generated from rpc omnios.v1.WorkspaceService.ListWorkspaces
     */
    listWorkspaces: {
      name: "ListWorkspaces",
      I: ListWorkspacesRequest,
      O: ListWorkspacesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkspaceService.GetWorkspace
     */
    getWorkspace: {
      name: "GetWorkspace",
      I: GetWorkspaceRequest,
      O: Workspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkspaceService.CreateWorkspace
     */
    createWorkspace: {
      name: "CreateWorkspace",
      I: CreateWorkspaceRequest,
      O: Workspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkspaceService.UpdateWorkspace
     */
    updateWorkspace: {
      name: "UpdateWorkspace",
      I: UpdateWorkspaceRequest,
      O: Workspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkspaceService.DeleteWorkspace
     */
    deleteWorkspace: {
      name: "DeleteWorkspace",
      I: DeleteWorkspaceRequest,
      O: Workspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkspaceService.UploadWorkspaceAvatar
     */
    uploadWorkspaceAvatar: {
      name: "UploadWorkspaceAvatar",
      I: UploadWorkspaceAvatarRequest,
      O: Workspace,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.WorkspaceService.ReportProblem
     */
    reportProblem: {
      name: "ReportProblem",
      I: ReportProblemRequest,
      O: ReportProblemResponse,
      kind: MethodKind.Unary,
    },
  }
};

